// Spanish UI catalog — generated from the English strings used in the JSX (English text is the key).
// Regenerate the key list with scripts/i18n-keys.mjs; keep entries in English order.
export const es: Record<string, string> = {
  "+ Add": "+ Añadir",
  "+ Task": "+ Tarea",
  "1 person notified": "1 persona notificada",
  "1 private project hidden": "1 proyecto privado oculto",
  "1 private project is hidden from these totals.": "1 proyecto privado está oculto en estos totales.",
  "1 project": "1 proyecto",
  "1 year": "1 año",
  "1. Scan the code with your authenticator app, or enter this key manually:": "1. Escanea el código con tu app de autenticación o introduce esta clave a mano:",
  "13 weeks": "13 semanas",
  "2. Enter the 6-digit code the app shows to confirm.": "2. Introduce el código de 6 dígitos que muestra la app para confirmar.",
  "26 weeks": "26 semanas",
  "30 days": "30 días",
  "4 weeks": "4 semanas",
  "8 weeks": "8 semanas",
  "90 days": "90 días",
  "A flag is a named on/off switch you control here without a deploy. Every signed-in browser receives the current flags, and features can check them to show or hide something.": "Un indicador es un interruptor con nombre que controlas aquí sin desplegar nada. Cada navegador con sesión iniciada recibe los indicadores actuales y las funciones pueden consultarlos para mostrar u ocultar algo.",
  "A person is": "Una persona está",
  "A portfolio groups related projects under one initiative (a client, a programme, a department) with a shared board, list and Gantt.": "Un portafolio agrupa proyectos relacionados bajo una misma iniciativa (un cliente, un programa, un departamento) con un tablero, una lista y un Gantt compartidos.",
  "A portfolio groups related projects under one initiative (a client, a programme, a department).": "Un portafolio agrupa proyectos relacionados bajo una misma iniciativa (un cliente, un programa, un departamento).",
  "A private project appears only in your own project list — no one else can see it, whatever their role": "Un proyecto privado aparece solo en tu propia lista de proyectos — nadie más puede verlo, sea cual sea su rol",
  "A simple sub-task with its own key; it appears here, not on the board": "Una subtarea sencilla con su propia clave; aparece aquí, no en el tablero",
  "A token acts as this person through the API: projects, portfolios, tasks, schedules and their time, never rates, payroll or admin. Everything it does is audited as them, marked with the token's name, and your name is recorded as the one who issued it.": "Un token actúa como esta persona a través de la API: proyectos, portafolios, tareas, cronogramas y su tiempo; nunca tarifas, nómina ni administración. Todo lo que hace queda auditado como esa persona, con el nombre del token, y tu nombre queda registrado como quien lo emitió.",
  "A token lets Claude Code (or a script) act as you through the API: projects, portfolios, tasks, schedules, links, milestones and your time. It never reaches rates, budgets, payroll, approvals, admin or account settings, whatever your role.": "Un token permite que Claude Code (o un script) actúe como tú a través de la API: proyectos, portafolios, tareas, cronogramas, enlaces, hitos y tu tiempo. Nunca accede a tarifas, presupuestos, nómina, aprobaciones, administración ni ajustes de cuenta, sea cual sea tu rol.",
  "API tokens": "Tokens de API",
  "Account": "Cuenta",
  "Accounts are invite-only. If you have an invite link, open it to set up your account.": "Las cuentas son solo por invitación. Si tienes un enlace de invitación, ábrelo para configurar tu cuenta.",
  "Action": "Acción",
  "Actions": "Acciones",
  "Active only": "Solo activas",
  "Add": "Añadir",
  "Add a comment": "Añadir un comentario",
  "Add a milestone on this day": "Añadir un hito en este día",
  "Add a person": "Añadir una persona",
  "Add a person…": "Añadir una persona…",
  "Add a status column (columns are the project's statuses)": "Añadir una columna de estado (las columnas son los estados del proyecto)",
  "Add a subtask under this task": "Añadir una subtarea bajo esta tarea",
  "Add a task due on this day": "Añadir una tarea con vencimiento este día",
  "Add a task in this column": "Añadir una tarea en esta columna",
  "Add a top-level task": "Añadir una tarea de nivel superior",
  "Add checklist item": "Añadir elemento de la lista",
  "Add column": "Añadir columna",
  "Add entry": "Añadir registro",
  "Add holiday": "Añadir festivo",
  "Add project…": "Añadir proyecto…",
  "Add rate": "Añadir tarifa",
  "Add subtask": "Añadir subtarea",
  "Add task": "Añadir tarea",
  "Add the column at the end; drag its header to reorder": "Añade la columna al final; arrastra su cabecera para reordenar",
  "Add the item": "Añadir el elemento",
  "Added": "Añadido",
  "Address / CIDR": "Dirección / CIDR",
  "Addresses on file (restriction currently off):": "Direcciones registradas (restricción desactivada ahora):",
  "Adds a second step to password sign-in: a 6-digit code from an app such as Google Authenticator, 1Password or Authy.": "Añade un segundo paso al inicio de sesión con contraseña: un código de 6 dígitos de una app como Google Authenticator, 1Password o Authy.",
  "Admin console": "Consola de administración",
  "After": "Después",
  "Alert at %": "Alertar al %",
  "All portfolios you can see; create one there": "Todos los portafolios que puedes ver; crea uno allí",
  "All projects": "Todos los proyectos",
  "All states": "Todos los estados",
  "Amount": "Importe",
  "An account for an integration, left out of payroll, timesheets and scheduled reports": "Una cuenta para una integración: queda fuera de la nómina, los partes de horas y los informes programados",
  "An invite lets them pick their own password. Creating an account here sends no email at all: it exists straight away, and you decide whether it has a password.": "Una invitación deja que elijan su propia contraseña. Crear una cuenta aquí no envía ningún correo: existe de inmediato y tú decides si tiene contraseña.",
  "Analytics": "Analítica",
  "Any action": "Cualquier acción",
  "Any milestone": "Cualquier hito",
  "Any priority": "Cualquier prioridad",
  "Any project": "Cualquier proyecto",
  "Any status": "Cualquier estado",
  "Anyone": "Cualquiera",
  "Approvals": "Aprobaciones",
  "Approve although it was not submitted — you'll be warned if the week is empty or thin, and the person is notified": "Aprobar aunque no se haya enviado — se te avisará si la semana está vacía o escasa, y se notifica a la persona",
  "Approve without submission?": "¿Aprobar sin envío?",
  "Approve — locks the week; any later work must be a correction entry": "Aprobar — bloquea la semana; cualquier trabajo posterior debe ser un registro de corrección",
  "Approve — reduces their available capacity for those days": "Aprobar — reduce su capacidad disponible esos días",
  "Approved": "Aprobado",
  "Archive": "Archivar",
  "Archive this portfolio? Its projects are unchanged; the portfolio drops out of the default lists.": "¿Archivar este portafolio? Sus proyectos no cambian; el portafolio desaparece de las listas predeterminadas.",
  "Assign to…": "Asignar a…",
  "Assignee": "Responsable",
  "At a glance": "De un vistazo",
  "At least 12 characters. A password found in a public breach is refused.": "Al menos 12 caracteres. Se rechaza una contraseña que aparezca en una filtración pública.",
  "At least 12 characters. A short sentence works well.": "Al menos 12 caracteres. Una frase corta funciona bien.",
  "Attach files": "Adjuntar archivos",
  "Attach files to the comment; you can also paste or drop them into it": "Adjunta archivos al comentario; también puedes pegarlos o soltarlos en él",
  "Attach files to this task; you can also drop them here": "Adjunta archivos a esta tarea; también puedes soltarlos aquí",
  "Attachments": "Adjuntos",
  "Auto-schedule": "Programación automática",
  "Avatar URL": "URL del avatar",
  "Awaiting approval": "Pendiente de aprobación",
  "Awaiting your approval": "Pendiente de tu aprobación",
  "Back": "Atrás",
  "Back to portfolios": "Volver a portafolios",
  "Back to projects": "Volver a proyectos",
  "Baseline": "Línea base",
  "Before": "Antes",
  "Bill rates": "Tarifas de facturación",
  "Billable + non": "Facturable + no",
  "Billable only": "Solo facturable",
  "Billable value": "Valor facturable",
  "Board": "Tablero",
  "Breadcrumb": "Ruta de navegación",
  "Budget": "Presupuesto",
  "Bulk-load people, projects, and an opening task backlog from CSV files.": "Carga masiva de personas, proyectos y un backlog inicial de tareas desde archivos CSV.",
  "Calendar": "Calendario",
  "Calendar settings": "Ajustes del calendario",
  "Cancel": "Cancelar",
  "Cancel this pending invite": "Cancelar esta invitación pendiente",
  "Cancel this request (or approved leave that hasn't started)": "Cancelar esta solicitud (o ausencia aprobada que aún no ha empezado)",
  "Capacity": "Capacidad",
  "Category": "Categoría",
  "Change any field on this person's record, including their email": "Cambiar cualquier campo de la ficha de esta persona, incluido su correo",
  "Change password": "Cambiar contraseña",
  "Change the email for {name} to {email}? That address is where password resets go, and they are told about the change.": "¿Cambiar el correo de {name} a {email}? A esa dirección llegan los restablecimientos de contraseña, y se le avisa del cambio.",
  "Changes save as you edit; this confirms and closes the editor": "Los cambios se guardan mientras editas; esto confirma y cierra el editor",
  "Checking invite…": "Comprobando invitación…",
  "Checking…": "Comprobando…",
  "Choose the timezone carefully — it cannot be changed afterwards.": "Elige la zona horaria con cuidado — no se puede cambiar después.",
  "Clear": "Borrar",
  "Click": "Haz clic",
  "Click the": "Haz clic en",
  "Close": "Cerrar",
  "Code": "Código",
  "Collapse": "Contraer",
  "Collapse this card": "Contraer esta tarjeta",
  "Collapse this section (remembered for you)": "Contraer esta sección (se recuerda para ti)",
  "Colour": "Color",
  "Delete {name}?": "¿Eliminar {name}?",
  "Download": "Descargar",
  "No files yet. Drop files here or use Attach files.": "Aún no hay archivos. Suelta archivos aquí o usa Adjuntar archivos.",
  "No files.": "No hay archivos.",
  "Owner": "Responsable",
  "Colour the task bars by owner (assignee). Remembered.": "Colorear las barras de tareas por responsable (persona asignada). Se recuerda.",
  "Colour for this calendar's events": "Color de los eventos de este calendario",
  "Column (status) name shown on the board": "Nombre de la columna (estado) que se muestra en el tablero",
  "Column name": "Nombre de columna",
  "Command": "Comando",
  "Command palette": "Paleta de comandos",
  "Comment": "Comentario",
  "Comment deleted": "Comentario eliminado",
  "Comment deleted by {name}": "Comentario eliminado por {name}",
  "Comments": "Comentarios",
  "Commit": "Confirmar",
  "Company holidays": "Festivos de la empresa",
  "Completed": "Completado",
  "Confirm new password": "Confirmar nueva contraseña",
  "Confirm password": "Confirmar contraseña",
  "Connect Google Calendar": "Conectar Google Calendar",
  "Connecting failed. Try again.": "La conexión falló. Inténtalo de nuevo.",
  "Continue with Google": "Continuar con Google",
  "Copied": "Copiado",
  "Copy all": "Copiar todo",
  "Copy link": "Copiar enlace",
  "Copy password": "Copiar contraseña",
  "Copy the claude mcp add command": "Copiar el comando claude mcp add",
  "Copy the export line": "Copiar la línea export",
  "Copy the password so you can pass it on": "Copiar la contraseña para poder entregarla",
  "Copy the token": "Copiar el token",
  "Correct…": "Corregir…",
  "Cost rate": "Tarifa de coste",
  "Cost rates": "Tarifas de coste",
  "Could not create portfolio": "No se pudo crear el portafolio",
  "Could not load the overview.": "No se pudo cargar el resumen.",
  "Create a one-time invite link (7 days) and email it if mail is configured": "Crear un enlace de invitación de un solo uso (7 días) y enviarlo por correo si el correo está configurado",
  "Create a project — you'll choose its permanent timezone-of-truth": "Crear un proyecto — elegirás su zona horaria de referencia permanente",
  "Create a task scheduled today for one week; drag its bar to adjust": "Crear una tarea programada hoy para una semana; arrastra su barra para ajustarla",
  "Create a top-level task in this project; open it afterwards to set dates, assignee, estimate": "Crear una tarea de nivel superior en este proyecto; ábrela después para fijar fechas, responsable y estimación",
  "Create account": "Crear cuenta",
  "Create feed link": "Crear enlace de feed",
  "Create invite": "Crear invitación",
  "Create one below, then file projects under it from a project's": "Crea uno abajo y luego archiva proyectos en él desde los",
  "Create one from the Portfolios page, then file projects under it from a project's": "Crea uno desde la página de Portafolios y luego incluye proyectos en él desde la página de cada proyecto, en",
  "Create project": "Crear proyecto",
  "Create the account now — nobody is emailed": "Crear la cuenta ahora — no se envía ningún correo",
  "Create the task": "Crear la tarea",
  "Create the task in this column": "Crear la tarea en esta columna",
  "Create token": "Crear token",
  "Create your personal feed link": "Crear tu enlace de feed personal",
  "Created": "Creado",
  "Cumulative flow": "Flujo acumulado",
  "Cumulative flow, cycle time, burndown, velocity, forecast": "Flujo acumulado, tiempo de ciclo, burndown, velocidad, previsión",
  "Currency": "Moneda",
  "Current password": "Contraseña actual",
  "Cycle (d)": "Ciclo (d)",
  "Dashboard, projects, members, settings": "Panel, proyectos, miembros, ajustes",
  "Dashboard, tasks, members, milestones, settings": "Panel, tareas, miembros, hitos, ajustes",
  "Date": "Fecha",
  "Dates": "Fechas",
  "Dates in": "Fechas en",
  "Day": "Día",
  "Deactivate your account (history is kept); you will be asked to confirm": "Desactivar tu cuenta (el historial se conserva); se te pedirá confirmación",
  "Decides whether this account can sign in the moment you create it": "Decide si esta cuenta puede iniciar sesión desde el momento en que la creas",
  "Decline with a reason; the person is notified": "Rechazar con un motivo; se notifica a la persona",
  "Delete": "Eliminar",
  "Delete column": "Eliminar columna",
  "Delete milestone": "Eliminar hito",
  "Delete task": "Eliminar tarea",
  "Delete this column (only when empty)": "Eliminar esta columna (solo si está vacía)",
  "Delete this comment? Its replies stay.": "¿Eliminar este comentario? Sus respuestas se mantienen.",
  "Delete this milestone": "Eliminar este hito",
  "Delete this task": "Eliminar esta tarea",
  "Delete this task (and its subtasks); logged time is kept": "Eliminar esta tarea (y sus subtareas); el tiempo registrado se conserva",
  "Remove this file": "Quitar este archivo",
  "Resize the task list": "Cambiar el tamaño de la lista de tareas",
  "Drag to resize the task list; double-click to reset": "Arrastra para cambiar el ancho de la lista de tareas; doble clic para restablecerlo",
  "Delete this task and its subtasks; logged time is kept": "Eliminar esta tarea y sus subtareas; el tiempo registrado se conserva",
  "Description": "Descripción",
  "Directory": "Directorio",
  "Discard": "Descartar",
  "Discuss this milestone": "Comentar este hito",
  "Discussion": "Conversación",
  "Dismiss": "Cerrar",
  "Display only — never changes which week an entry belongs to.": "Solo para mostrar — nunca cambia a qué semana pertenece un registro.",
  "Does not match.": "No coincide.",
  "Done": "Hecho",
  "Download CSV": "Descargar CSV",
  "Download a JSON file with everything stored about you": "Descargar un archivo JSON con todo lo almacenado sobre ti",
  "Download as a PDF table": "Descargar como tabla PDF",
  "Download as an Excel workbook": "Descargar como libro de Excel",
  "Download everything stored about you — profile, memberships, time entries, tasks assigned, leave, approvals, notifications — as JSON.": "Descarga todo lo almacenado sobre ti — perfil, membresías, registros de tiempo, tareas asignadas, ausencias, aprobaciones, notificaciones — como JSON.",
  "Download my data": "Descargar mis datos",
  "Download partial CSV": "Descargar CSV parcial",
  "Download these rows as CSV": "Descargar estas filas como CSV",
  "Drag cards, or focus a card and press": "Arrastra tarjetas, o enfoca una tarjeta y pulsa",
  "Drag to change priority; Space + arrows works from the keyboard": "Arrastra para cambiar la prioridad; Espacio + flechas funciona desde el teclado",
  "Drag to move between columns or reorder; Space + arrows works from the keyboard": "Arrastra para mover entre columnas o reordenar; Espacio + flechas funciona desde el teclado",
  "Drop idle time — save up to the idle moment, then restart": "Descartar el tiempo inactivo — guardar hasta el momento de inactividad y reiniciar",
  "Due": "Vence",
  "Each status maps to a global category (to do / in progress / done / archived) so reporting works across projects. Keep at least one per category. Archived work is left out of every count and hidden unless asked for.": "Cada estado se asigna a una categoría global (por hacer / en curso / hecho / archivado) para que los informes funcionen entre proyectos. Mantén al menos uno por categoría. El trabajo archivado queda fuera de todos los recuentos y oculto salvo que se pida.",
  "Archived": "Archivado",
  "Also show tasks in an archived status. Remembered, and shared by the task views and the board.": "Mostrar también las tareas en un estado archivado. La elección se recuerda y la comparten las vistas de tareas y el tablero.",
  "Upload failed": "Error al subir",
  "Uploading 1 file…": "Subiendo 1 archivo…",
  "Uploading {n} files…": "Subiendo {n} archivos…",
  "Waterfall": "Cascada",
  "Lay linked tasks out left to right: any task that overlaps what its links allow moves later (keeping its length), then rows are ordered by start, linked ones in link order. Done and archived tasks stay put. Saved; press again after changes.": "Disponer las tareas vinculadas de izquierda a derecha: cualquier tarea que se solape con lo que permiten sus vínculos se retrasa (conservando su duración) y luego las filas se ordenan por inicio, las vinculadas en orden de vínculo. Las tareas hechas y archivadas no se mueven. Se guarda; vuelve a pulsarlo tras cambios.",
  "Waterfall:": "Cascada:",
  "in a comment": "en un comentario",
  "rescheduled": "reprogramadas",
  "reordered": "reordenadas",
  "Already a waterfall: nothing to change": "Ya es una cascada: nada que cambiar",
  "Could not reschedule the tasks": "No se pudieron replanificar las tareas",
  "Auto-schedule:": "Planificación automática:",
  "Already scheduled: nothing to change": "Ya está planificado: nada que cambiar",
  "Auto-schedule replans every open task: in-progress work first, then linked tasks as soon as their links allow and others from today, so nobody gets two tasks at once. Continue?": "La planificación automática replanifica cada tarea abierta: primero el trabajo en curso, luego las vinculadas en cuanto lo permiten sus vínculos y las demás desde hoy, para que nadie tenga dos tareas a la vez. ¿Continuar?",
  "Plan the open tasks as soon as possible: linked ones right after their links allow, unlinked past or undated ones from today (undated take their estimate at 8h a day, or 5 days), future unlinked ones keep their start. Each person's tasks are queued, in-progress first and then by priority, so they never overlap, counting their other projects. Done and archived tasks stay put. Saved.": "Planificar lo antes posible las tareas abiertas: las vinculadas justo cuando lo permiten sus vínculos, las no vinculadas pasadas o sin fechas desde hoy (las sin fechas toman su estimación a 8 h por día, o 5 días), las futuras no vinculadas conservan su inicio. Las tareas de cada persona se encolan, primero las en curso y luego por prioridad, para que nunca se solapen, contando sus otros proyectos. Las tareas hechas y archivadas no se mueven. Se guarda.",
  "working days": "días laborables",
  "estimated": "estimadas",
  "Edit": "Editar",
  "Edit person": "Editar persona",
  "Edit your comment; the previous text is kept as history": "Edita tu comentario; el texto anterior se guarda como historial",
  "Elapsed": "Transcurrido",
  "Email": "Correo",
  "End this session and return to the sign-in page (other devices stay signed in)": "Cerrar esta sesión y volver a la página de inicio de sesión (los demás dispositivos siguen conectados)",
  "Ends": "Termina",
  "Enter the 6-digit code from your authenticator app, or one of your recovery codes.": "Introduce el código de 6 dígitos de tu app de autenticación, o uno de tus códigos de recuperación.",
  "Epic": "Épica",
  "Estimate (h)": "Estimación (h)",
  "Every project-week approved": "Todas las semanas de proyecto aprobadas",
  "Everyone": "Todos",
  "Everyone (admin)": "Todos (admin)",
  "Everyone in the range is approved — download the payroll CSV": "Todos en el rango están aprobados — descarga el CSV de nómina",
  "Everything on this person's record. Changes are audit-logged against your name.": "Todo lo que hay en la ficha de esta persona. Los cambios quedan en el registro de auditoría a tu nombre.",
  "Examples:": "Ejemplos:",
  "Excludes people who still have unapproved weeks; they are named in the file header": "Excluye a quienes aún tienen semanas sin aprobar; se nombran en la cabecera del archivo",
  "Expand": "Expandir",
  "Expand this card to see details": "Expandir esta tarjeta para ver detalles",
  "Expand this section (remembered for you)": "Expandir esta sección (se recuerda para ti)",
  "Expires": "Caduca",
  "External calendars (in)": "Calendarios externos (entrada)",
  "Feature flags": "Indicadores de funciones",
  "Field": "Campo",
  "Filter the list by project code or name": "Filtrar la lista por código o nombre de proyecto",
  "Final step: deactivate the account now": "Último paso: desactivar la cuenta ahora",
  "For an integration such as Claude Code rather than a colleague: it stays out of payroll, timesheets and scheduled reports.": "Para una integración como Claude Code, no para un colega: queda fuera de la nómina, los partes de horas y los informes programados.",
  "Format": "Formato",
  "From": "Desde",
  "From your calendar today": "De tu calendario de hoy",
  "Global category this column maps to, so cross-project reports keep working": "Categoría global a la que corresponde esta columna, para que los informes entre proyectos sigan funcionando",
  "Google did not grant offline access — remove ADKOM PM under your Google account’s third-party access, then connect again.": "Google no concedió acceso sin conexión — elimina ADKOM PM del acceso de terceros de tu cuenta de Google y vuelve a conectar.",
  "Grant read-only access; today's meetings become one-click time entry suggestions": "Conceder acceso de solo lectura; las reuniones de hoy se convierten en sugerencias de registro de tiempo con un clic",
  "Group by": "Agrupar por",
  "Group the board into rows by assignee, epic or priority": "Agrupar el tablero en filas por responsable, épica o prioridad",
  "Has unapproved weeks": "Tiene semanas sin aprobar",
  "Hidden projects are a personal view preference; nothing about the project changes": "Los proyectos ocultos son una preferencia personal de vista; nada del proyecto cambia",
  "Hide subtasks": "Ocultar subtareas",
  "Show only tasks in progress, hiding the backlog and done. Remembered, and shared by the task views.": "Mostrar solo las tareas en curso, ocultando el backlog y las terminadas. La elección se recuerda y la comparten las vistas de tareas.",
  "Hide tasks that are done. Remembered, and shared by the task views.": "Ocultar las tareas terminadas. La elección se recuerda y la comparten las vistas de tareas.",
  "Show backlog": "Mostrar backlog",
  "With \"Active only\" on, also show tasks still in the backlog. Remembered.": "Con \"Solo activas\" activado, mostrar también las tareas que siguen en el backlog. La elección se recuerda.",
  "Hide this milestone's discussion": "Ocultar la conversación de este hito",
  "Hide this project from your lists (just for you; the project is unchanged)": "Ocultar este proyecto de tus listas (solo para ti; el proyecto no cambia)",
  "Hide this project's tasks": "Ocultar las tareas de este proyecto",
  "Hours": "Horas",
  "Hours (30d)": "Horas (30d)",
  "Hours for other members are visible to project administrators and managers.": "Las horas de otros miembros son visibles para administradores de proyecto y gestores.",
  "Hours per week": "Horas por semana",
  "Hours/wk": "Horas/sem",
  "How much of their time the schedule may plan for.": "Cuánto de su tiempo puede planificar el cronograma.",
  "IP allowlist set by an administrator": "Lista de IP permitidas definida por un administrador",
  "Identifies this project's tasks on portfolio boards and Gantts": "Identifica las tareas de este proyecto en los tableros y Gantts del portafolio",
  "Import": "Importar",
  "Import in order: people → projects → tasks.": "Importa en este orden: personas → proyectos → tareas.",
  "In progress": "En curso",
  "Include accounts used by integrations, which are hidden by default": "Incluir las cuentas que usan las integraciones, ocultas de forma predeterminada",
  "Invite": "Invitar",
  "Invite colleagues and manage roles.": "Invita a compañeros y gestiona roles.",
  "Invite for": "Invitación para",
  "Issue a token for this person and show it once": "Emitir un token para esta persona y mostrarlo una sola vez",
  "Issue or revoke tokens that act as this person through the API": "Emitir o revocar tokens que actúan como esta persona a través de la API",
  "Issues assigned to this GitHub user become tasks assigned to them.": "Los issues asignados a este usuario de GitHub se convierten en tareas asignadas a esa persona.",
  "Job title": "Puesto",
  "Jump to the current week": "Ir a la semana actual",
  "Jump to the top of the page": "Ir al principio de la página",
  "Jump to top": "Ir arriba",
  "Kanban board across every project in the portfolio": "Tablero Kanban con todos los proyectos del portafolio",
  "Kanban board: drag cards between status columns": "Tablero Kanban: arrastra tarjetas entre columnas de estado",
  "Keep": "Conservar",
  "Keep the account": "Conservar la cuenta",
  "Keep — count the idle time as work": "Conservar — contar el tiempo inactivo como trabajo",
  "Keeps this account out of payroll, timesheets and scheduled reports.": "Mantiene esta cuenta fuera de la nómina, los partes de horas y los informes programados.",
  "Key": "Clave",
  "Kind": "Tipo",
  "Label": "Etiqueta",
  "Language": "Idioma",
  "Last": "Último",
  "Last active": "Última actividad",
  "Last run": "Última ejecución",
  "Last sign-in": "Último inicio de sesión",
  "Last used": "Último uso",
  "Leave": "Ausencias",
  "Leave it empty to follow the organisation's working week.": "Déjalo vacío para seguir la semana laboral de la organización.",
  "Line": "Línea",
  "List": "Lista",
  "Loading…": "Cargando…",
  "Log time →": "Registrar tiempo →",
  "Logged": "Registrado",
  "Managed by": "Gestionado por",
  "Manager": "Gestor",
  "Markdown · type @ to mention someone · Ctrl-Enter posts": "Markdown · escribe @ para mencionar a alguien · Ctrl-Intro publica",
  "Median cycle time": "Tiempo de ciclo mediano",
  "Median lead time": "Tiempo de entrega mediano",
  "Member": "Miembro",
  "Members": "Miembros",
  "Mention someone": "Mencionar a alguien",
  "Milestone": "Hito",
  "Milestones": "Hitos",
  "Milestone…": "Hito…",
  "Mine open": "Mis abiertas",
  "Month": "Mes",
  "Month view of due dates, milestones and external calendars": "Vista mensual de vencimientos, hitos y calendarios externos",
  "More actions for this row": "Más acciones para esta fila",
  "Move this status up one place": "Subir este estado una posición",
  "Move up": "Subir",
  "Moving a project out of a portfolio is refused while it has cross-project links": "No se puede sacar un proyecto de un portafolio mientras tenga enlaces entre proyectos",
  "My private projects": "Mis proyectos privados",
  "My reports": "Mis informes",
  "My requests": "Mis solicitudes",
  "My tasks": "Mis tareas",
  "Name": "Nombre",
  "New milestone": "Nuevo hito",
  "New password": "Nueva contraseña",
  "New portfolio": "Nuevo portafolio",
  "New portfolio name": "Nombre del nuevo portafolio",
  "New project": "Nuevo proyecto",
  "New status": "Nuevo estado",
  "New subtask": "Nueva subtarea",
  "New task": "Nueva tarea",
  "New task in": "Nueva tarea en",
  "New task title": "Título de la nueva tarea",
  "New timer": "Nuevo temporizador",
  "Next milestone": "Próximo hito",
  "Next month": "Mes siguiente",
  "Next run": "Próxima ejecución",
  "Next week": "Semana siguiente",
  "No comments yet.": "Aún no hay comentarios.",
  "No completed work in the window yet.": "Aún no hay trabajo completado en la ventana.",
  "No cost rate yet.": "Aún no hay tarifa de coste.",
  "No data.": "Sin datos.",
  "No earlier versions.": "No hay versiones anteriores.",
  "No feed link yet.": "Aún no hay enlace de feed.",
  "No hours budget set.": "No hay presupuesto de horas.",
  "No members yet.": "Aún no hay miembros.",
  "No milestones yet.": "Aún no hay hitos.",
  "No money budget set.": "No hay presupuesto de dinero.",
  "No open milestones with a due date.": "No hay hitos abiertos con fecha de vencimiento.",
  "No portfolios yet.": "Aún no hay portafolios.",
  "No projects filed here yet.": "Aún no hay proyectos incluidos aquí.",
  "No projects in this portfolio yet.": "Aún no hay proyectos en este portafolio.",
  "No projects match.": "Ningún proyecto coincide.",
  "No projects yet.": "Aún no hay proyectos.",
  "No projects.": "No hay proyectos.",
  "No tasks yet.": "Aún no hay tareas.",
  "No tasks.": "No hay tareas.",
  "No time in this range.": "No hay tiempo en este rango.",
  "No time in this window.": "No hay tiempo en esta ventana.",
  "No time matches.": "Ningún tiempo coincide.",
  "No tokens yet.": "Todavía no hay tokens.",
  "Non-billable only": "Solo no facturable",
  "None": "Ninguno",
  "None yet.": "Aún nada.",
  "Not available — approvals are for project administrators.": "No disponible — las aprobaciones son para administradores de proyecto.",
  "Not configured on this server.": "No configurado en este servidor.",
  "Not enough history yet for a trend — the weekly chart appears after two weeks of entries.": "Aún no hay historial suficiente para una tendencia — el gráfico semanal aparece tras dos semanas de registros.",
  "Not enough history yet for trends and forecasts — they firm up after a couple of weeks of tasks moving. What is here is exact, just short.": "Aún no hay historial suficiente para tendencias y previsiones — se afianzan tras un par de semanas de movimiento de tareas. Lo que hay aquí es exacto, solo breve.",
  "Not enough history yet — the chart appears once two project weeks have entries.": "Aún no hay historial suficiente — el gráfico aparece cuando dos semanas de proyecto tengan registros.",
  "Not submitted": "No enviado",
  "Note": "Nota",
  "Note (optional)": "Nota (opcional)",
  "Note saved onto the entry": "Nota guardada en el registro",
  "Note saved onto the time entry when you stop": "Nota guardada en el registro de tiempo al parar",
  "Notes": "Notas",
  "Nothing assigned to you.": "Nada asignado a ti.",
  "Nothing completed yet.": "Aún nada completado.",
  "Nothing here.": "Nada aquí.",
  "Nothing logged yet.": "Aún nada registrado.",
  "Nothing recorded yet.": "Aún nada grabado.",
  "Nothing to preview yet.": "Todavía no hay nada que previsualizar.",
  "Nothing yet.": "Aún nada.",
  "Notifications": "Notificaciones",
  "Now click the task that must wait for": "Ahora haz clic en la tarea que debe esperar a",
  "On enter": "Al entrar",
  "One submission per project per week, in each project's own timezone.": "Un envío por proyecto y semana, en la zona horaria de cada proyecto.",
  "Only ephemeral records are ever purged. Business history — time entries, approvals, tasks, the audit log, status transitions — is never touched.": "Solo se purgan registros efímeros. El historial de negocio — registros de tiempo, aprobaciones, tareas, el registro de auditoría, transiciones de estado — nunca se toca.",
  "Only you can see these. Drag to prioritize.": "Solo tú puedes verlos. Arrastra para priorizar.",
  "Open People": "Abrir Personas",
  "Open People: directory, roles, invites": "Abrir Personas: directorio, roles, invitaciones",
  "Open Projects": "Abrir Proyectos",
  "Open Reports to slice logged time": "Abrir Informes para desglosar el tiempo registrado",
  "Open portfolio →": "Abrir portafolio →",
  "Open tasks": "Tareas abiertas",
  "Open the Gantt chart": "Abrir el diagrama de Gantt",
  "Open the Kanban board": "Abrir el tablero Kanban",
  "Open the Time page: edit timers, notes, tasks": "Abrir la página de Tiempo: editar temporizadores, notas, tareas",
  "Open the portfolio": "Abrir el portafolio",
  "Open the portfolio: shared board, list and Gantt across its projects": "Abrir el portafolio: tablero, lista y Gantt compartidos entre sus proyectos",
  "Open the project": "Abrir el proyecto",
  "Open the task": "Abrir la tarea",
  "Outstanding": "Pendiente",
  "Overdue": "Atrasadas",
  "Overview": "Resumen",
  "Parent": "Padre",
  "Password": "Contraseña",
  "Paste CSV here…": "Pega el CSV aquí…",
  "Pause": "Pausar",
  "Pause this timer; time is kept": "Pausar este temporizador; el tiempo se conserva",
  "Pause; time is kept": "Pausar; el tiempo se conserva",
  "Payroll export": "Exportación de nómina",
  "Pending": "Pendiente",
  "People": "Personas",
  "Per-project feeds:": "Feeds por proyecto:",
  "Permanent. Create a new project to use a different zone.": "Permanente. Crea un proyecto nuevo para usar otra zona.",
  "Person": "Persona",
  "Person…": "Persona…",
  "Pick the range by": "Elige el rango por",
  "Portfolio": "Portafolio",
  "Portfolio manager": "Gestor del portafolio",
  "Portfolio not found, or you do not have access.": "Portafolio no encontrado, o no tienes acceso.",
  "Portfolio role": "Rol en el portafolio",
  "Portfolio roles grant access to the merged views; task edits still follow each project's own membership.": "Los roles del portafolio dan acceso a las vistas combinadas; la edición de tareas sigue dependiendo de la membresía de cada proyecto.",
  "Portfolios": "Portafolios",
  "Portfolios don't affect approvals — they add a shared board, list and Gantt, and cross-project links.": "Los portafolios no afectan a las aprobaciones — añaden un tablero, una lista y un Gantt compartidos, y enlaces entre proyectos.",
  "Portfolios don't affect permissions or approvals — they are purely for organising and reporting.": "Los portafolios no afectan a permisos ni aprobaciones — son solo para organizar e informar.",
  "Portfolios →": "Portafolios →",
  "Post the comment": "Publicar el comentario",
  "Post the comment (Ctrl-Enter)": "Publicar el comentario (Ctrl-Intro)",
  "Prev": "Ant.",
  "Preview": "Vista previa",
  "Previous month": "Mes anterior",
  "Previous week": "Semana anterior",
  "Priority": "Prioridad",
  "Priority…": "Prioridad…",
  "Private projects filed here that only their owners can see": "Proyectos privados incluidos aquí que solo sus propietarios pueden ver",
  "Private — only you can see this project": "Privado — solo tú puedes ver este proyecto",
  "Private — only you will see this project": "Privado — solo tú verás este proyecto",
  "Progress": "Progreso",
  "Project": "Proyecto",
  "Project colour": "Color del proyecto",
  "Project not found, or you do not have access.": "Proyecto no encontrado, o no tienes acceso.",
  "Project not found.": "Proyecto no encontrado.",
  "Project role": "Rol en el proyecto",
  "Project the new task belongs to": "Proyecto al que pertenece la nueva tarea",
  "Projected finish": "Fin previsto",
  "Projects": "Proyectos",
  "Projects not yet in a portfolio that you may update": "Proyectos que puedes modificar y que aún no están en un portafolio",
  "Projects you are a member of.": "Proyectos de los que eres miembro.",
  "Projects you can see. Managers and admins see all.": "Proyectos que puedes ver. Gestores y admins ven todos.",
  "Purge immediately using the currently saved policy (not unsaved edits) and record the counts above": "Purgar ahora mismo con la política guardada actualmente (no las ediciones sin guardar) y anotar los recuentos arriba",
  "Push successors when a task moves": "Desplazar las sucesoras cuando una tarea se mueve",
  "Range": "Rango",
  "Rates are visible to managers and administrators.": "Las tarifas son visibles para gestores y administradores.",
  "Read this first.": "Lee esto primero.",
  "Read tokens can only look; write tokens can also create and change tasks, links, milestones and time entries. Everything a token does is audited as you, marked with the token's name.": "Los tokens de lectura solo pueden consultar; los de escritura también pueden crear y modificar tareas, enlaces, hitos y registros de tiempo. Todo lo que hace un token se audita como tú, marcado con el nombre del token.",
  "Read-only: today’s meetings appear as one-click suggestions on the Time page. Your entries flow back to any calendar through the": "Solo lectura: las reuniones de hoy aparecen como sugerencias de un clic en la página de Tiempo. Tus registros vuelven a cualquier calendario a través del",
  "Read: look only. Write: create and change tasks, links, milestones and time": "Lectura: solo consultar. Escritura: crear y cambiar tareas, enlaces, hitos y tiempo",
  "Ready": "Listo",
  "Recently completed": "Completadas recientemente",
  "Regenerate": "Regenerar",
  "Regenerate link": "Regenerar enlace",
  "Regenerate recovery codes": "Regenerar códigos de recuperación",
  "Regenerate the secret link (old link stops working)": "Regenerar el enlace secreto (el enlace antiguo deja de funcionar)",
  "Remove": "Quitar",
  "Remove item": "Quitar elemento",
  "Remove this calendar": "Quitar este calendario",
  "Remove this checklist item": "Quitar este elemento de la lista",
  "Remove this comment; its replies stay": "Quitar este comentario; sus respuestas se mantienen",
  "Repeats": "Se repite",
  "Reply": "Responder",
  "Reply in this thread": "Responder en este hilo",
  "Report name": "Nombre del informe",
  "Reports": "Informes",
  "Request": "Solicitar",
  "Request failed": "La solicitud falló",
  "Request leave": "Solicitar ausencia",
  "Reset your password": "Restablecer tu contraseña",
  "Result": "Resultado",
  "Resume": "Reanudar",
  "Resume (pauses the running timer)": "Reanudar (pausa el temporizador en marcha)",
  "Resume this timer (pauses the running one)": "Reanudar este temporizador (pausa el que está en marcha)",
  "Retake baseline": "Volver a tomar línea base",
  "Retention": "Retención",
  "Return the week with a note; the person edits and resubmits": "Devolver la semana con una nota; la persona la edita y reenvía",
  "Revoke": "Revocar",
  "Revoke the token \"{name}\"? Anything using it stops working immediately.": "¿Revocar el token «{name}»? Todo lo que lo use deja de funcionar de inmediato.",
  "Revoked:": "Revocados:",
  "Role": "Rol",
  "Run this report automatically on the chosen cadence and deliver it by email/notification": "Ejecutar este informe automáticamente con la cadencia elegida y entregarlo por correo/notificación",
  "Save": "Guardar",
  "Save every change on this record": "Guardar todos los cambios de esta ficha",
  "Save policy": "Guardar política",
  "Save policy stores the numbers for the nightly run. Run now purges immediately with the saved policy.": "Guardar política almacena los números para la ejecución nocturna. Ejecutar ahora purga de inmediato con la política guardada.",
  "Save the current grouping and filters under a name": "Guardar la agrupación y filtros actuales con un nombre",
  "Save these recovery codes now.": "Guarda estos códigos de recuperación ahora.",
  "Saved reports…": "Informes guardados…",
  "Saved ✓": "Guardado ✓",
  "Saved.": "Guardado.",
  "Schedule": "Programar",
  "Schedule end": "Fin programado",
  "Schedule settings per project": "Ajustes de programación por proyecto",
  "Scheduled reports": "Informes programados",
  "Scope": "Alcance",
  "Scroll the timeline back to today": "Desplazar la línea de tiempo hasta hoy",
  "Search": "Buscar",
  "Search code or name…": "Buscar código o nombre…",
  "Search…": "Buscar…",
  "Send the request to your line manager (some types are approved automatically)": "Enviar la solicitud a tu gestor (algunos tipos se aprueban automáticamente)",
  "Send them a password reset link from the directory when they are ready to sign in.": "Envíale un enlace de restablecimiento desde el directorio cuando pueda iniciar sesión.",
  "Send them this link — it is shown once and expires in 7 days:": "Envíales este enlace — se muestra una vez y caduca en 7 días:",
  "Send this project-week to the project administrator for approval; you can withdraw until they decide": "Enviar esta semana de proyecto al administrador del proyecto para su aprobación; puedes retirarla hasta que decida",
  "Sent back": "Devuelto",
  "Service account": "Cuenta de servicio",
  "Set a new password for": "Establecer una nueva contraseña para",
  "Set a password": "Establecer una contraseña",
  "Set status…": "Establecer estado…",
  "Set the task and a note when you start, or edit them in the list.": "Establece la tarea y una nota al iniciar, o edítalas en la lista.",
  "Set up your account": "Configura tu cuenta",
  "Settings": "Ajustes",
  "Share with project": "Compartir con el proyecto",
  "Show": "Mostrar",
  "Show archived": "Mostrar archivados",
  "Show failed sign-in attempts": "Mostrar intentos de inicio de sesión fallidos",
  "Show service accounts": "Mostrar cuentas de servicio",
  "Show sign-in attempts": "Mostrar intentos de inicio de sesión",
  "Show subtasks": "Mostrar subtareas",
  "Show the audit log": "Mostrar el registro de auditoría",
  "Show the comment formatted, as it will appear": "Mostrar el comentario con formato, tal como aparecerá",
  "Show this project in your lists again": "Volver a mostrar este proyecto en tus listas",
  "Show this project's tasks": "Mostrar las tareas de este proyecto",
  "Show what this comment said before it was edited": "Ver lo que decía este comentario antes de editarse",
  "Shows their day in the right hours; it never changes which week an entry belongs to.": "Muestra su jornada en las horas correctas; nunca cambia a qué semana pertenece un registro.",
  "Sign in": "Iniciar sesión",
  "Sign in with your device's fingerprint, face or PIN, or a hardware key — no password or code needed. Passkeys are phishing-resistant.": "Inicia sesión con la huella, la cara o el PIN de tu dispositivo, o una llave física — sin contraseña ni código. Las llaves de acceso resisten el phishing.",
  "Sign out": "Cerrar sesión",
  "Signed in": "Sesión iniciada",
  "Signing in…": "Iniciando sesión…",
  "Since": "Desde",
  "Sortable table of tasks across every project in the portfolio": "Tabla ordenable de tareas de todos los proyectos del portafolio",
  "Sortable table of tasks with bulk edit and saved views": "Tabla ordenable de tareas con edición masiva y vistas guardadas",
  "Start (or switch) your timer for this project onto this task; any running timer pauses": "Iniciar (o cambiar) tu temporizador de este proyecto a esta tarea; cualquier temporizador en marcha se pausa",
  "Start a timer for this project (pauses any running timer)": "Iniciar un temporizador para este proyecto (pausa cualquier temporizador en marcha)",
  "Start timer": "Iniciar temporizador",
  "Start timer on this task": "Iniciar temporizador en esta tarea",
  "Starts": "Empieza",
  "State": "Estado",
  "Status": "Estado",
  "Stop and save": "Parar y guardar",
  "Stop and save one time entry for the total": "Parar y guardar un registro de tiempo por el total",
  "Stop and save one time entry for the total on this project": "Parar y guardar un registro de tiempo por el total en este proyecto",
  "Stop anything using this token, immediately": "Detener de inmediato todo lo que use este token",
  "Stop at idle — save up to the idle moment and stop": "Parar en la inactividad — guardar hasta ese momento y parar",
  "Stop reading your Google Calendar": "Dejar de leer tu Google Calendar",
  "Stop the timer running on this task and save one time entry": "Parar el temporizador de esta tarea y guardar un registro de tiempo",
  "Stop timer": "Parar temporizador",
  "Store these numbers as the policy; the nightly purge uses them from its next run": "Guardar estos números como política; la purga nocturna los usa desde su próxima ejecución",
  "Subscribe": "Suscribir",
  "Subscribe your calendar app to this link to see your tasks (due dates), leave, your projects' milestones and your last 90 days of time entries.": "Suscribe tu app de calendario a este enlace para ver tus tareas (vencimientos), ausencias, los hitos de tus proyectos y tus últimos 90 días de registros de tiempo.",
  "Subscribe your calendar app to your tasks, leave, milestones and recent time entries.": "Suscribe tu app de calendario a tus tareas, ausencias, hitos y registros de tiempo recientes.",
  "Swimlanes": "Carriles",
  "System state, the audit trail, and sign-in activity. People and invites are under": "Estado del sistema, el rastro de auditoría y la actividad de inicio de sesión. Personas e invitaciones están en",
  "Take baseline": "Tomar línea base",
  "Take the project out of this portfolio (the project itself is unchanged)": "Sacar el proyecto de este portafolio (el proyecto en sí no cambia)",
  "Take the submission back to edit the week; resubmit when ready": "Retirar el envío para editar la semana; reenvía cuando esté lista",
  "Task": "Tarea",
  "Task (optional)": "Tarea (opcional)",
  "Task this timer is for (optional)": "Tarea a la que corresponde este temporizador (opcional)",
  "Task title": "Título de la tarea",
  "Tasks": "Tareas",
  "Tasks can't move between projects": "Las tareas no pueden moverse entre proyectos",
  "Tasks live inside projects; open Projects": "Las tareas viven dentro de proyectos; abre Proyectos",
  "Team (last 30 days)": "Equipo (últimos 30 días)",
  "That does not look like a valid zone.": "Eso no parece una zona válida.",
  "The calendar's public iCal URL": "La URL iCal pública del calendario",
  "The link is a secret — anyone holding it can read your feed. Regenerate it if it leaks.": "El enlace es un secreto — cualquiera que lo tenga puede leer tu feed. Regenéralo si se filtra.",
  "The numbers below are the": "Los números de abajo son la",
  "The person accountable for the portfolio; always a portfolio administrator": "La persona responsable del portafolio; siempre es administrador del portafolio",
  "The token is shown once, when you create it. Revoke it here if it leaks.": "El token se muestra una sola vez, al crearlo. Revócalo aquí si se filtra.",
  "Then start Claude Code and ask it, for example, \"what is overdue across my portfolio?\" or \"plan the importer epic in DEN with four tasks and link them\".": "Luego abre Claude Code y pídele, por ejemplo, «¿qué está atrasado en mi portafolio?» o «planifica la épica del importador en DEN con cuatro tareas y enlázalas».",
  "There is no password yet, so nobody can sign in as them. Issue a password reset link from the directory when they are ready.": "Todavía no hay contraseña, así que nadie puede iniciar sesión como esta persona. Emite un enlace de restablecimiento desde el directorio cuando esté lista.",
  "They can sign in with the password you set.": "Puede iniciar sesión con la contraseña que has puesto.",
  "This account can only be used from these addresses (set by an administrator):": "Esta cuenta solo se puede usar desde estas direcciones (definido por un administrador):",
  "This browser does not support passkeys.": "Este navegador no admite llaves de acceso.",
  "This invite is invalid or has expired. Ask an administrator for a new one.": "Esta invitación no es válida o ha caducado. Pide una nueva a un administrador.",
  "This password is shown once and will not be shown again. Give it to them over a channel you trust; they can change it under Account.": "Esta contraseña se muestra una sola vez y no volverá a mostrarse. Entrégasela por un canal de confianza; podrá cambiarla en Cuenta.",
  "Throw this timer away without saving": "Descartar este temporizador sin guardar",
  "Time": "Tiempo",
  "Time is approved per project, per week, in each project's own timezone.": "El tiempo se aprueba por proyecto y semana, en la zona horaria de cada proyecto.",
  "Time off is approved by your line manager and reduces your available capacity for that week — it never counts as hours worked.": "Las ausencias las aprueba tu gestor y reducen tu capacidad disponible esa semana — nunca cuentan como horas trabajadas.",
  "Timeline across projects: cross-project links, critical path": "Línea de tiempo entre proyectos: enlaces entre proyectos, ruta crítica",
  "Timeline: drag bars, link dependencies, critical path, baseline": "Línea de tiempo: arrastra barras, enlaza dependencias, ruta crítica, línea base",
  "Timesheets": "Partes de horas",
  "Timezone": "Zona horaria",
  "Timezone of truth": "Zona horaria de referencia",
  "Title": "Título",
  "Title of the new task; you can fill in the rest from the task editor": "Título de la nueva tarea; el resto lo puedes rellenar desde el editor de tareas",
  "To": "Hasta",
  "To confirm, type your name exactly:": "Para confirmar, escribe tu nombre exactamente:",
  "To connect Claude Code as this account, put the token in the shell and add the server once:": "Para conectar Claude Code como esta cuenta, pon el token en el shell y añade el servidor una vez:",
  "To do": "Por hacer",
  "To use it from Claude Code, put it in your shell and add the server once:": "Para usarlo desde Claude Code, ponlo en tu shell y añade el servidor una vez:",
  "Token": "Token",
  "Token name, e.g. Claude Code": "Nombre del token, p. ej. Claude Code",
  "Token name, e.g. Claude Code on my laptop": "Nombre del token, p. ej. Claude Code en mi portátil",
  "Top": "Arriba",
  "Turn off": "Desactivar",
  "Turn off authenticator": "Desactivar autenticador",
  "Turn on": "Activar",
  "Type": "Tipo",
  "Type @ to mention someone · Ctrl-Enter posts": "Escribe @ para mencionar a alguien · Ctrl-Intro publica",
  "Type a command, project, task key, or name…  (Ctrl-K toggles)": "Escribe un comando, proyecto, clave de tarea o nombre…  (Ctrl-K alterna)",
  "Type your display name exactly to enable the final button": "Escribe tu nombre para mostrar exactamente para habilitar el botón final",
  "Unarchive": "Desarchivar",
  "Unassigned": "Sin asignar",
  "Unlock an approved week for edits; requires a reason, recorded in the audit log, and notifies the person": "Desbloquear una semana aprobada para editarla; requiere un motivo, se anota en el registro de auditoría y se notifica a la persona",
  "Unshare": "Dejar de compartir",
  "Upcoming milestones": "Próximos hitos",
  "Update password": "Actualizar contraseña",
  "Upload": "Subir",
  "Use them to try a change with a few people first, or to switch a feature off quickly if it misbehaves.": "Úsalos para probar un cambio primero con pocas personas, o para desactivar rápidamente una función si falla.",
  "Velocity": "Velocidad",
  "Velocity (estimate hours done per week)": "Velocidad (horas estimadas completadas por semana)",
  "Velocity per week": "Velocidad por semana",
  "Verify": "Verificar",
  "Views…": "Vistas…",
  "WIP limit": "Límite WIP",
  "Week": "Semana",
  "Week of": "Semana del",
  "Weeks awaiting submission": "Semanas pendientes de envío",
  "Weeks from": "Semanas desde",
  "Weeks run Monday→Monday in": "Las semanas van de lunes a lunes en",
  "What": "Qué",
  "What did you work on?": "¿En qué trabajaste?",
  "What they see the app in until they choose otherwise.": "El idioma en el que ven la aplicación hasta que elijan otro.",
  "What this person costs per hour (effective-dated); click to view history or change it": "Lo que cuesta esta persona por hora (con fecha de vigencia); haz clic para ver el historial o cambiarlo",
  "When": "Cuándo",
  "When done, the next occurrence is created with dates shifted.": "Al terminar, se crea la siguiente repetición con las fechas desplazadas.",
  "When the token stops working on its own": "Cuándo deja de funcionar el token por sí solo",
  "Where password resets go. Change it and they are emailed about it.": "Adonde llegan los restablecimientos de contraseña. Si lo cambias, se le avisa por correo.",
  "Which project the new timer is for": "A qué proyecto pertenece el nuevo temporizador",
  "Who": "Quién",
  "Working days per week": "Días laborables por semana",
  "Write": "Escribir",
  "Write a comment…": "Escribe un comentario…",
  "Write a reply…": "Escribe una respuesta…",
  "You are not a member of any project yet, so there is nowhere to log time. Ask a project administrator to add you.": "Aún no eres miembro de ningún proyecto, así que no hay dónde registrar tiempo. Pide a un administrador de proyecto que te añada.",
  "You become its portfolio manager; add projects and members from the portfolio page, or file a project from its": "Te conviertes en su gestor; añade proyectos y miembros desde la página del portafolio, o incluye un proyecto desde sus",
  "You can also send them the link directly:": "También puedes enviarles el enlace directamente:",
  "You can see this project's tasks here but not change them": "Puedes ver aquí las tareas de este proyecto, pero no cambiarlas",
  "You do not have access to this page.": "No tienes acceso a esta página.",
  "You have been invited as": "Has sido invitado como",
  "You have no line manager set, so requests will wait for an administrator. Ask an admin to set your manager under People.": "No tienes gestor asignado, así que las solicitudes esperarán a un administrador. Pide a un admin que asigne tu gestor en Personas.",
  "You need edit rights in both projects to link them": "Necesitas permisos de edición en ambos proyectos para enlazarlos",
  "You sign in with Google, which handles two-factor authentication for you. These options apply to password sign-in.": "Inicias sesión con Google, que gestiona la autenticación de dos factores por ti. Estas opciones se aplican al inicio de sesión con contraseña.",
  "You sign in with Google. A password gives you a fallback if Google is unavailable.": "Inicias sesión con Google. Una contraseña te da una alternativa si Google no está disponible.",
  "Your colleagues.": "Tus compañeros.",
  "Your feed (out)": "Tu feed (salida)",
  "Your name": "Tu nombre",
  "Your own zone, for display. Projects keep their own timezone-of-truth.": "Tu propia zona, para mostrar. Los proyectos conservan su zona horaria de referencia.",
  "Your role": "Tu rol",
  "Your role requires a second factor for password sign-in. Set up an": "Tu rol requiere un segundo factor para iniciar sesión con contraseña. Configura una",
  "Your week is shown in": "Tu semana se muestra en",
  "active people": "personas activas",
  "active projects": "proyectos activos",
  "approvals arrive in Phase 3": "las aprobaciones llegan en la Fase 3",
  "archived": "archivado",
  "assignee: clear": "responsable: quitar",
  "assignee: keep": "responsable: mantener",
  "audit trail for this project": "rastro de auditoría de este proyecto",
  "billable hours": "horas facturables",
  "billed amount": "importe facturado",
  "by": "por",
  "change in Settings": "cambiar en Ajustes",
  "closes Monday": "cierra el lunes",
  "comments and @mentions about the project as a whole": "comentarios y @menciones sobre el proyecto en conjunto",
  "correction": "corrección",
  "cost": "coste",
  "cost / hour": "coste / hora",
  "created": "creado",
  "created → done": "creado → hecho",
  "created. Copy it now — it will not be shown again.": "creado. Cópialo ahora: no se volverá a mostrar.",
  "critical tasks": "tareas críticas",
  "current": "actual",
  "current + new + confirm": "actual + nueva + confirmar",
  "current 6-digit code": "código actual de 6 dígitos",
  "days": "días",
  "deleted": "eliminado",
  "description, dashboard": "descripción, panel",
  "devices signed in as you": "dispositivos con tu sesión iniciada",
  "done": "hecho",
  "download everything stored about you": "descarga todo lo almacenado sobre ti",
  "due +days": "vence +días",
  "edited": "editado",
  "edited by": "editado por",
  "estimate hours": "horas estimadas",
  "every 2 weeks": "cada 2 semanas",
  "every day": "cada día",
  "every month": "cada mes",
  "every quarter": "cada trimestre",
  "every week": "cada semana",
  "extra recipients (comma-separated)": "destinatarios adicionales (separados por comas)",
  "failed sign-ins (24h)": "inicios de sesión fallidos (24h)",
  "feed URL, Google Calendar, external calendars": "URL del feed, Google Calendar, calendarios externos",
  "fingerprint, face, security key": "huella, cara, llave de seguridad",
  "for Claude Code and scripts": "para Claude Code y scripts",
  "from": "de",
  "generate one and show it to me once": "generar una y mostrármela una vez",
  "hidden": "oculto",
  "hours": "horas",
  "hours and money caps, alerts": "límites de horas y dinero, alertas",
  "hours logged": "horas registradas",
  "hours logged (yours where restricted)": "horas registradas (las tuyas donde haya restricción)",
  "iCal subscription link": "enlace de suscripción iCal",
  "in": "en",
  "in progress": "en curso",
  "kept": "conservado",
  "last 30 days": "últimos 30 días",
  "last month": "mes pasado",
  "last week": "semana pasada",
  "latest scheduled finish across projects": "último fin programado entre los proyectos",
  "list view, editor, checklists": "vista de lista, editor, listas de verificación",
  "live sessions": "sesiones activas",
  "logged this week": "registrado esta semana",
  "median cycle time (days)": "tiempo de ciclo mediano (días)",
  "median lead time (days)": "tiempo de entrega mediano (días)",
  "migrations": "migraciones",
  "month to date": "mes en curso",
  "name, dates, timezone, archive": "nombre, fechas, zona horaria, archivar",
  "name, description, portfolio manager, archive": "nombre, descripción, gestor del portafolio, archivar",
  "name, language, timezone": "nombre, idioma, zona horaria",
  "navigate · Enter run · Esc close": "navegar · Intro ejecutar · Esc cerrar",
  "never": "nunca",
  "never expires": "nunca caduca",
  "no estimates yet": "aún sin estimaciones",
  "no rate — billable time counts as unrated": "sin tarifa — el tiempo facturable cuenta como sin tarifa",
  "no scheduled tasks yet": "aún sin tareas programadas",
  "non-billable": "no facturable",
  "none yet": "aún ninguna",
  "none — portfolio views assign a palette colour": "ninguno — las vistas de portafolio asignan un color de la paleta",
  "none — they cannot sign in yet": "ninguna — todavía no puede iniciar sesión",
  "now has an account.": "ya tiene una cuenta.",
  "off": "desactivada",
  "office, home…": "oficina, casa…",
  "on": "activada",
  "open tasks assigned to me": "tareas abiertas asignadas a mí",
  "or set a password": "o establece una contraseña",
  "or use a password": "o usa una contraseña",
  "overdue": "atrasado",
  "overdue ·": "atrasado ·",
  "payroll-ready": "listo para nómina",
  "people are": "personas están",
  "permanent — read first": "permanente — léelo primero",
  "person is": "persona está",
  "person's zone": "zona de la persona",
  "policy": "política",
  "portfolio": "portafolio",
  "portfolio administrator": "administrador del portafolio",
  "portfolio end": "fin del portafolio",
  "predecessor": "predecesor",
  "priority: keep": "prioridad: mantener",
  "private": "privado",
  "project administrator": "administrador del proyecto",
  "project zone": "zona del proyecto",
  "projected finish": "fin previsto",
  "projects": "proyectos",
  "rate / hour": "tarifa / hora",
  "read and write": "lectura y escritura",
  "read only": "solo lectura",
  "read this once": "léelo una vez",
  "read-only": "solo lectura",
  "rejected — resubmit": "rechazado — reenviar",
  "service account": "cuenta de servicio",
  "set one now": "poner una ahora",
  "subtask": "subtarea",
  "synced": "sincronizado",
  "system": "sistema",
  "taken": "tomada el",
  "task count": "número de tareas",
  "tasks": "tareas",
  "tasks done": "tareas hechas",
  "then": "luego",
  "this device": "este dispositivo",
  "this week": "esta semana",
  "throughput": "rendimiento",
  "time entries": "registros de tiempo",
  "time-based codes (TOTP)": "códigos temporales (TOTP)",
  "to": "a",
  "to do": "por hacer",
  "two-way sync": "sincronización bidireccional",
  "unassigned": "sin asignar",
  "updated": "actualizado",
  "velocity (h / week)": "velocidad (h / semana)",
  "via API token": "mediante token de API",
  "week start": "inicio de semana",
  "weeks awaiting submission": "semanas pendientes de envío",
  "workflow columns and transitions": "columnas de flujo y transiciones",
  "your hours logged": "tus horas registradas",
  "your password": "tu contraseña",
  "zero slack: a delay moves the end date": "holgura cero: un retraso mueve la fecha de fin",
  "{n} people notified": "{n} personas notificadas",
  "{n} private projects are hidden from these totals.": "{n} proyectos privados están ocultos en estos totales.",
  "{n} private projects hidden": "{n} proyectos privados ocultos",
  "{n} projects": "{n} proyectos",
  "— (top level)": "— (nivel superior)",
  "— no task —": "— sin tarea —",
  "— none —": "— ninguno —",
  "— unassigned —": "— sin asignar —",
  "🔒 approved": "🔒 aprobado",
  "Task completed.": "Tarea completada.",
  "Task reopened.": "Tarea reabierta.",
  "+ sub": "+ sub",
  "Burndown / burnup": "Burndown / burnup",
  "Est.": "Est.",
  "Gantt": "Gantt",
  "Lead (d)": "Lead (d)",
  "Total": "Total",
  "Zoom": "Zoom",
  "est. h": "est. h",
  "Applies immediately to this browser and every device you sign in on; overrides the browser language.": "Se aplica de inmediato a este navegador y a todos los dispositivos donde inicies sesión; sustituye el idioma del navegador.",
  "A confirmation link was sent to the new address (valid 2 days). Your email changes when you open it.": "Se envió un enlace de confirmación a la nueva dirección (válido 2 días). Tu correo cambia cuando lo abras.",
  "Cancel it": "Cancelarlo",
  "Change email": "Cambiar correo",
  "Change now": "Cambiar ahora",
  "Change now (with password)": "Cambiar ahora (con contraseña)",
  "Change the email immediately": "Cambiar el correo de inmediato",
  "Changed. Use the new address next time you sign in.": "Cambiado. Usa la nueva dirección la próxima vez que inicies sesión.",
  "Confirm email": "Confirmar correo",
  "Done — your sign-in email is now": "Listo — tu correo de inicio de sesión ahora es",
  "Either way the old address is told, and the change is recorded in the audit log.": "En ambos casos se avisa a la dirección antigua y el cambio queda en el registro de auditoría.",
  "Mail is not configured on this server, so open this link yourself (valid 2 days):": "El correo no está configurado en este servidor, así que abre este enlace tú mismo (válido 2 días):",
  "New email": "Nuevo correo",
  "Send a confirmation link to the new address": "Enviar un enlace de confirmación a la nueva dirección",
  "Send confirmation link": "Enviar enlace de confirmación",
  "This account signs in with Google, so its email is managed by Google and cannot be changed here.": "Esta cuenta inicia sesión con Google, así que su correo lo gestiona Google y no se puede cambiar aquí.",
  "Verify first": "Verificar primero",
  "Verify first (send a link)": "Verificar primero (enviar un enlace)",
  "Waiting for confirmation of": "Esperando confirmación de",
  "Your email is what you sign in with and where notifications are mailed.": "Tu correo es con el que inicias sesión y adonde se envían las notificaciones.",
  "a link is sent to the new address; the change happens when you open it, so a typo can't lock you out.": "se envía un enlace a la nueva dirección; el cambio ocurre cuando lo abres, así que una errata no te dejará fuera.",
  "enter your current password and the address changes immediately.": "introduce tu contraseña actual y la dirección cambia de inmediato.",
  "expires": "caduca",
  "A status update is waiting to be sent to GitHub": "Hay una actualización de estado pendiente de enviarse a GitHub",
  "API calls left this hour": "llamadas a la API restantes esta hora",
  "Assign to matching people": "Asignar a las personas coincidentes",
  "Close and reopen issues when task status changes": "Cerrar y reabrir issues cuando cambie el estado de la tarea",
  "Connect": "Conectar",
  "Connect a repository to import its issues as tasks. When a task is finished here, the issue is closed on GitHub; when an issue is closed or reopened on GitHub, the task follows.": "Conecta un repositorio para importar sus issues como tareas. Cuando una tarea termina aquí, el issue se cierra en GitHub; cuando un issue se cierra o reabre en GitHub, la tarea le sigue.",
  "Connected to": "Conectado a",
  "Could not load the GitHub connection.": "No se pudo cargar la conexión con GitHub.",
  "Create missing milestones": "Crear hitos que falten",
  "Disconnect": "Desconectar",
  "Disconnect this repository? Existing issue links are kept; nothing is deleted on GitHub.": "¿Desconectar este repositorio? Los enlaces a issues existentes se conservan; no se borra nada en GitHub.",
  "Fine-grained personal access token": "Token de acceso personal de grano fino",
  "GITHUB_WEBHOOK_SECRET is not set on the server, so changes made on GitHub reach APM by hourly polling or “Sync now” rather than instantly.": "GITHUB_WEBHOOK_SECRET no está configurado en el servidor, así que los cambios hechos en GitHub llegan a APM por sondeo cada hora o con «Sincronizar ahora», no al instante.",
  "GitHub": "GitHub",
  "GitHub username": "Usuario de GitHub",
  "GitHub → Settings → Developer settings → Fine-grained tokens. Limit it to this repository with permission Issues: Read and write (Metadata is included automatically). The token is verified now, stored encrypted, and never shown again.": "GitHub → Settings → Developer settings → Fine-grained tokens. Limítalo a este repositorio con el permiso Issues: Read and write (Metadata se incluye automáticamente). El token se verifica ahora, se guarda cifrado y no se vuelve a mostrar.",
  "Import issues": "Importar issues",
  "Import issues…": "Importar issues…",
  "Importing…": "Importando…",
  "Issue closed as completed →": "Issue cerrado como completado →",
  "Issue closed as not planned →": "Issue cerrado como no planificado →",
  "Issue reopened →": "Issue reabierto →",
  "Issues assigned to this GitHub user become tasks assigned to you when a project imports them.": "Los issues asignados a este usuario de GitHub se convierten en tareas asignadas a ti cuando un proyecto los importa.",
  "Labels": "Etiquetas",
  "Mirror the task status as an apm:… label": "Reflejar el estado de la tarea como etiqueta apm:…",
  "Moving a task into this status closes the issue as “not planned”; any other done status closes it as “completed”.": "Mover una tarea a este estado cierra el issue como «no planificado»; cualquier otro estado de hecho lo cierra como «completado».",
  "No APM account has this GitHub username": "Ninguna cuenta de APM tiene este usuario de GitHub",
  "No issues match.": "Ningún issue coincide.",
  "Priority from labels": "Prioridad según etiquetas",
  "Replace the token or test the connection to resume.": "Sustituye el token o prueba la conexión para reanudar.",
  "Replace token": "Sustituir token",
  "Repository": "Repositorio",
  "Status mapping": "Correspondencia de estados",
  "Sync history": "Historial de sincronización",
  "Sync is paused:": "La sincronización está en pausa:",
  "Sync now": "Sincronizar ahora",
  "Synced:": "Sincronizado:",
  "Syncing…": "Sincronizando…",
  "Test connection": "Probar conexión",
  "Webhook: add": "Webhook: añade",
  "When an imported issue carries one of these labels, the task gets the matching priority (first match wins).": "Cuando un issue importado lleva una de estas etiquetas, la tarea recibe la prioridad correspondiente (gana la primera coincidencia).",
  "all": "todos",
  "already linked": "ya enlazados",
  "attempt": "intento",
  "checked": "revisados",
  "closed": "cerrado",
  "create": "crear",
  "errors": "errores",
  "failed": "fallidos",
  "first done status": "primer estado de hecho",
  "first to-do status": "primer estado por hacer",
  "import issues as tasks, sync status": "importar issues como tareas, sincronizar estado",
  "label, e.g. bug": "etiqueta, p. ej. bug",
  "labels, comma-separated": "etiquetas, separadas por comas",
  "last checked": "última comprobación",
  "linked issues": "issues enlazados",
  "next": "siguiente",
  "not planned": "no planificado",
  "nothing to do": "nada que hacer",
  "open": "abierto",
  "open issues": "issues abiertos",
  "page": "página",
  "previous": "anterior",
  "remove": "quitar",
  "running": "en curso",
  "same as completed": "igual que completado",
  "search title or #number": "buscar título o #número",
  "sent to GitHub": "enviados a GitHub",
  "to the repository with the server's GITHUB_WEBHOOK_SECRET, content type JSON, events: Issues, Pushes, Pull requests. Without it, changes still arrive by hourly polling or “Sync now”.": "al repositorio con el GITHUB_WEBHOOK_SECRET del servidor, tipo de contenido JSON, eventos: Issues, Pushes, Pull requests. Sin él, los cambios siguen llegando por sondeo cada hora o con «Sincronizar ahora».",
  "token": "token",
  "update": "actualizar",
  "update pending": "actualización pendiente",
  "updated here": "actualizados aquí",
  "updates waiting": "actualizaciones en espera",
  "Open menu": "Abrir menú",
  "Close menu": "Cerrar menú",
  "Main menu": "Menú principal",
  "Management": "Gestión",
}
